export const CURRENCY_SYMBOL = '$'

export const getPrice = (price = '') => +`${price}`.replace(CURRENCY_SYMBOL, '')

export const formatPrice = (number) =>
  number < 0 ? `-$${-number.toFixed(2)}` : `$${number.toFixed(2)}`

export const getFormattedPrice = (price) =>
  price < 0 ? `-${formatPrice(-price)}` : formatPrice(price)

export const toNumber = (currencyString = '') => {
  const cleanValue = currencyString.replace(/[^0-9.-]/g, '')

  return parseFloat(cleanValue)
}
